import { render, staticRenderFns } from "./MapLegendPanel.vue?vue&type=template&id=1efb6820&scoped=true&"
import script from "./MapLegendPanel.vue?vue&type=script&lang=js&"
export * from "./MapLegendPanel.vue?vue&type=script&lang=js&"
import style0 from "./MapLegendPanel.vue?vue&type=style&index=0&id=1efb6820&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efb6820",
  null
  
)

export default component.exports